import React, { useMemo } from 'react';
import Search from './Search';
import { useLocation } from 'react-router';
import MiscellaneousPublicSearch from './MiscellaneousPublicSearch';

const PublicSearchWrapper = (props) => {
  const location = useLocation()
  const { sublinks } = props

  const isMiscRecordsType = useMemo(() => {
    const parts = location.pathname.split('/')
    const sublink = sublinks.find(x => x.parameter === parts[parts.length -1])
    if (sublink) {
      return sublink.IsMiscRecordsType
    } else {
      return false
    }
  }, [location, sublinks])

  if (isMiscRecordsType) return <MiscellaneousPublicSearch {...props} />;
  
  return ( <Search {...props} /> );
}

export default PublicSearchWrapper